var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBottom),expression:"isBottom"}],staticClass:"btn-go-to-top",on:{"click":function($event){return _vm.clickGoToTop()}}},[_vm._v(" Go to Top ")])
}
var staticRenderFns = []

export { render, staticRenderFns }